import { Reveal } from "@/components/motion/Reveal";
import { ArrowUpRight } from "lucide-react";

const APP_URL = "https://vote-estimate.emergent.host";

export default function ProposalAI() {
  return (
    <section id="proposal-ai" className="proposal-ai bg-white" data-testid="proposal-ai">
      {/* HERO banner (full-bleed, retina 16:9) with real CTA hotspot */}
      <div className="relative w-full">
        <h1 className="sr-only">Build a proposal in minutes.</h1>
        <img
          src="/marketing/proposal-ai-hero.jpg"
          alt="SmartBallot Proposal AI — Build a proposal in minutes. From voting-event details to a polished, client-ready PDF with accurate cost estimates."
          className="w-full block"
        />
        <a
          href={APP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="proposal-ai-hero-cta"
          aria-label="Start a proposal"
          title="Start a proposal"
          className="absolute rounded-full"
          style={{ left: "4.5%", top: "69%", width: "15%", height: "8%" }}
        />
      </div>

      {/* HOW IT WORKS — single full-width graphic */}
      <div className="mx-auto max-w-[1100px] px-6 md:px-10 pb-20 md:pb-24">
        <Reveal>
          <img
            src="/marketing/how-it-works-1200x675.png"
            alt="How it works: enter event details, see a live cost estimate, add recipient info, and get a client-ready proposal"
            className="w-full rounded-2xl"
          />
        </Reveal>
      </div>

      {/* CTA band */}
      <div className="pa-gradient">
        <div className="mx-auto max-w-[1200px] px-6 md:px-10 py-16 md:py-20 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
          <h2 className="pa-head text-3xl md:text-4xl font-extrabold text-white">
            Ready to build your proposal?
          </h2>
          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="proposal-ai-cta-band"
            className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white font-semibold shadow-lg shadow-black/10 hover:bg-white/90 transition-colors duration-300 shrink-0"
            style={{ color: "#DE2A68" }}
          >
            Start a proposal
            <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
